import { Controller, useFieldArray } from "react-hook-form";
import { Row, Col, Form } from "react-bootstrap";
import Select from "react-select";

import { useEffect, useState } from "react";
import { getData } from "../../../../utils/api";
import { Select2Data } from "../../../../utils/common";

const EditOnSection = ({
  index,
  control,
  register,
  getValues,
  errors,
  setValue,
  addOn,
  setAddOn,
  watch,
  getAllAddOn,
}) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: `add_on_category.${index}.add_on`,
  });

  const [categories, setCategories] = useState([]);

  const getAllCategories = async () => {
    const response = await getData("/common/masters/all-vendor-p-categories");
    if (response?.success) {
      setCategories(await Select2Data(response?.data, "p_category_id"));
    }
  };
  const [days, setDays] = useState([]);
  const getAllDays = async () => {
    const response = await getData("/common/masters/all-days");
    if (response?.success) {
      setDays(await Select2Data(response?.data, "day_id"));
    }
  };

  useEffect(() => {
    getAllCategories();
    getAllDays();
  }, []);
  useEffect(() => {
    const category = watch(`add_on_category.${index}.addon_category_id`);

    if (category?.value) {
      getAllAddOn(category.value);
    }
  }, [watch(`add_on_category.${index}.addon_category_id`)]);

  return (
    <>
      {fields.map((delivery, add_onIndex) => (
        <div key={delivery.id} className="border p-3 mb-3 mt-3">
          <Row className="mb-5">
            <h5>Add on {add_onIndex + 1}</h5>

            <Col md={4}>
              <Form.Group className="mt-2">
                <Form.Label>Add On</Form.Label>
                <Form.Group className="mt-2">
                  <Controller
                    control={control}
                    name={`add_on_category.${index}.add_on.${add_onIndex}.addon_id`}
                    rules={{
                      required: "Add On is required", // ✅ required validation
                    }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={addOn}
                        placeholder="Select Add On"
                        onChange={(selectedOption) => {
                          field.onChange(selectedOption?.value || "");
                          setValue(
                            `add_on_category.${index}.add_on.${add_onIndex}.addon_id`,
                            selectedOption
                          );
                        }}
                      />
                    )}
                  />
                  {errors?.add_on_category?.[index]?.add_on?.[add_onIndex]
                    ?.addon_id && (
                    <span className="text-danger">
                      {
                        errors.add_on_category[index].add_on[add_onIndex]
                          .addon_id.message
                      }
                    </span>
                  )}
                </Form.Group>
              </Form.Group>
            </Col>

            <Col md={4}>
              <div className="main-form-section mt-3">
                <Row className="justify-content-center">
                  <Form.Label>Price</Form.Label>
                  <Form.Group>
                    <Form.Control
                      type="text"
                      name={`add_on_category.${index}.add_on.${add_onIndex}.price`} // Register color for the variant
                      placeholder="Price"
                      {...register(
                        `add_on_category.${index}.add_on.${add_onIndex}.price`,
                        {
                          required: "Price is required",
                        }
                      )}
                      onKeyDown={(e) => {
                        // Allow backspace, left and right arrow keys
                        if (
                          e.key === "Backspace" ||
                          e.key === "ArrowLeft" ||
                          e.key === "ArrowRight"
                        ) {
                          return; // Allow the action to continue
                        }

                        // Allow digits and decimal point
                        if (!/[\d.]/.test(e.key)) {
                          e.preventDefault(); // Block the invalid key
                        }

                        // Prevent multiple decimal points
                        if (e.key === "." && e.target.value.includes(".")) {
                          e.preventDefault(); // Block adding another decimal point
                        }
                      }}
                    />
                    {errors?.add_on_category?.[index]?.add_on?.[add_onIndex]
                      ?.price?.message && (
                      <span className="text-danger">
                        {
                          errors.add_on_category[index].add_on[add_onIndex]
                            .price.message
                        }
                      </span>
                    )}
                  </Form.Group>
                </Row>
              </div>
            </Col>
          </Row>

          <button
            type="button"
            className="btn btn-danger mb-3"
            onClick={() => remove(add_onIndex)}
          >
            Remove Add on
          </button>
        </div>
      ))}
      <div className="text-center">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => append({ products: [] })}
        >
          + Add Add On
        </button>
      </div>
    </>
  );
};

export default EditOnSection;
